import ModulesLoader from './modulesLoader';
import FormValidation from './modules/formValidation';

const modules = {
    'formValidation': FormValidation
};

window.addEventListener('load', () => {
    const modulesLoader = new ModulesLoader(modules);
    modulesLoader.init();
});
